import { Component, OnInit, Optional } from '@angular/core';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { LearnMoreComponent } from '../learn-more/learn-more.component';
import { ApiService } from '../../../services/api.service';
import { UtilityService } from '../../../services/utility.service';
import { apiErrorHandler } from '../../../constants/api-error-handler';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-create-organization-dialog',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './create-organization-dialog.component.html',
  styleUrl: './create-organization-dialog.component.scss',
})
export class CreateOrganizationDialogComponent implements OnInit {
  private meriPehchanUrl!: string;
  private nssoAuthSubs?: Subscription;

  constructor(
    @Optional()
    private matDialogRef: MatDialogRef<CreateOrganizationDialogComponent> | null,
    private matDialog: MatDialog,
    private apiService: ApiService,
    private utilService: UtilityService
  ) {
    if (matDialogRef) matDialogRef.disableClose = true;
  }

  ngOnInit() {
    this.matDialogRef.addPanelClass('create-organization-dialog');
  }

  openLearnMoreDialog() {
    this.matDialogRef.close();
    this.matDialog
      .open(LearnMoreComponent, {
        autoFocus: true,
        disableClose: true,
        maxWidth: '726px',
        maxHeight: 'calc(100vh - 5rem)',
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.getMeriPehchaanUrl();
        }
      });
  }

  getMeriPehchaanUrl() {
    this.nssoAuthSubs = this.apiService.fetchNssoAuth().subscribe({
      next: (res) => {
        this.meriPehchanUrl = res;
        this.utilService.openExternalPage(this.meriPehchanUrl);
      },
      error: apiErrorHandler.bind(this),
    });
  }

  ngOnDestroy() {
    this.nssoAuthSubs?.unsubscribe();
  }
}
